import React                       from "react";
import Drawer                      from "@mui/material/Drawer";

import { Button                  } from "src/components/common/button";
import { RadioGroup, 
         RadioGroupItem          } from "src/components/common/radio-group";
import { Textarea                } from "src/components/common/textarea";
import { Typography              } from "src/components/common/typography";

import { Container,
         LabelContainer,
         RadioButtonContainer,
         TextAreaContainer,
         ActionsContainer,
         result_dialog_variants,
         ResultDialogVariants,   } from "src/components/features/main/product-count-result-dialog/ui";

import { storeApi, 
         useAppDispatch, 
         useAppSelector          } from "src/store";

import { Urls                    } from "src/providers/routing";



export const RADIO_ITEM_LIST = [
  {
    id: "1",
    label: "Да",
  },
  {
    id: "2",
    label: "Нет",
  },
];

type Props = {
  isOpened: boolean;
  variant: ResultDialogVariants;
};
export const ProductCountResultDialog: React.FC<Props> = ({ isOpened, variant = 'result_dialog_main' }) => {
  const lookAndFeel = result_dialog_variants.get(variant)!;

  const selectedItem = useAppSelector(
    storeApi.main.mainProductCountResultDialog.selectors.selectSelectedItem
  );
  const commentValue = useAppSelector(
    storeApi.main.mainProductCountResultDialog.selectors.selectCommentValue
  );

  const resultImg = useAppSelector(
    storeApi.main.mainProductCounter.selectors.selectResultUploadImage
  );

  const resultsCounterStatus = useAppSelector(
    storeApi.main.mainProductCounter.selectors.selectResultsCounterStatus
  );

  const dispatch = useAppDispatch();

  const handleSend = () => {
    dispatch(storeApi.main.mainProductCountResultDialog.action.setIsOpened());
    if (resultImg)
    {
      dispatch(
        storeApi.main.mainProductCounter.async.uploadFBForImageAsync({
          guid: resultImg?.ticket,
          numberOfSheets: resultsCounterStatus?.number_of_sheets || 0,
        })
      );
      dispatch(storeApi.main.mainProductCountResultDialog.action.resetState());
      Urls.MainProductCounter.build().navigate();
    }
  };

  const handleSelectRadioItem = (value: RadioGroupItem) => {
    dispatch(
      storeApi.main.mainProductCountResultDialog.action.setSelectedItem(value)
    );
  };

  const handleChange = (value: string) => {
    dispatch(
      storeApi.main.mainProductCountResultDialog.action.setCommentValue(value)
    );
  };

  return (
    <Drawer anchor = 'bottom' open = { isOpened }>
      <Container lookAndFeel = { lookAndFeel }>
        <LabelContainer lookAndFeel = { lookAndFeel }>
          <Typography variant = 'blackw400s16lh22'>
            Вы удовлетворены результатом подсчета?
          </Typography>
        </LabelContainer>

        <RadioButtonContainer lookAndFeel = { lookAndFeel }>
          <RadioGroup
            layout = 'horizontal-left'
            variant = 'light'
            value = { selectedItem }
            items = { RADIO_ITEM_LIST }
            onChange = { handleSelectRadioItem }
          />
        </RadioButtonContainer>

        <TextAreaContainer lookAndFeel = { lookAndFeel }>
          <Textarea
            name = 'product-counter-result-name'
            label = 'Комментарий'
            placeholder = 'Введите комментарий'
            value = { commentValue }
            onChange = { handleChange }
            variant = 'textarea_main'
          />
        </TextAreaContainer>

        <ActionsContainer lookAndFeel = { lookAndFeel }>
          <Button
            variant = 'h48bluefillrounnd'
            onTap = { handleSend }
            label = 'Отправить результат'
            isDisabled = { selectedItem.id === '2' && commentValue.trim().length === 0 }
          />
        </ActionsContainer>
      </Container>
    </Drawer>
  );
};
